export enum ValueType {
  PERSON = 'Person',
  FEMALE = 'Female',
  MALE = 'Male',
  CITY = 'City',
  NATION = 'Nation',
  DEVICE = 'Device',
}

export class Value {
  constructor(
    public type: string,
    public value: string,
  ) { }

  public toString() {
    return this.type + " / " + this.value;
  }
}
